import React from 'react'
import { DepartmentButton, EqStdButton, RefreshButton } from './DepartmentButton'
import styled from 'styled-components'

/*  print legend on same page  */
const ListContainer = styled.div`
  padding-top: 10px;
  padding-right: 10px;
  padding-bottom: 0px;
  box-sizing: border-box;
  pointer-events: none;
  background: transparent;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: calc(100vh - 200px);
  width: auto;
  
  @media print {
	  height: 100%
  }

  @media (max-width: 768px) {
	height: calc(100vh - 305px);
	padding-right: 0px;
  }

  @media (max-width: 420px) {
	display: none;
  }
`

/*  print legend on separate page  */
/* 
const ListContainer = styled.div`
  height: calc(100vh - 200px);
  width: auto;
  padding-right: 10px;
  padding-bottom: 0px;
  box-sizing: border-box;
  pointer-events: none;
  background: transparent;
  page-break-before: always;
  
  @media print {
	  height: 100%
	  width: 100%
  }

  @media (max-width: 768px) {
    height: calc(100vh - 305px);
    padding-right: 0px;
  }

  @media (max-width: 420px) {
    display: none;
  }
`
 */
/*
const OverflowContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  position: relative;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  pointer-events: auto;
`
*/
/*  print legend on same page  */
const OverflowContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
  padding-left: 60px;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  pointer-events: auto;
  
  @media print {
	  padding-left: 60px;
	  justify-content: center;
  }
`

/* 
  @media print {
	  display: flex;
	  flex-direction: column;
	  flex-wrap: wrap;
	  justify-content: center;
	  align-content: center;
	  padding-left: 60px;
	  height: auto;
  }
 */
 
/*  print legend on separate page  */
/* 
const OverflowContainer = styled.div`
  height: 100%;
  position: relative;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  pointer-events: auto;
  
  @media print {
	  width: 30%;
	  display: flex;
	  flex-direction: column;
	  justify-content: center;
	  padding-top: 40px;
	  padding-left: 60px;
  }
`
 */
 
const StyledUnorderedList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  pointer-events: auto;
  > * {
	  &:first-child {
		  padding-top: 6px;
	  }
  }
`

const StyledUnorderedList2 = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  pointer-events: auto;
  > * {
	  &:first-child {
		  padding-top: 6px;
	  }
  }
`

const StyledUnorderedList3 = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  pointer-events: auto;
`

const StyledLi = styled.li`
  line-height: 0px;
`
/*
const DepartmentList = ({departments, onDepartmentTap}) => {
  const onClick = buttonProps => {
    const {dv_id, dp_id} = buttonProps
    onDepartmentTap(dv_id, dp_id)
  }

  let departmentList = Object.values(departments)
  return departmentList.length ? (
    <ListContainer>
      <OverflowContainer>
        <StyledUnorderedList>
          {departmentList.map(item => {
            const {dv_id, dp_id, color, department} = item
            return (
              dp_id && (
                <li key={dv_id + dp_id}>
                  <DepartmentButton
                    label={department || dp_id}
                    color={color}
                    onClick={onClick}
                    {...item}
                  />
                </li>
              )
            )
          })}
        </StyledUnorderedList>
      </OverflowContainer>
    </ListContainer>
  ) : null
}
*/

const DepartmentList = ({eqstds, onEqStdTap, departments, onDepartmentTap}) => {
  const onClick = buttonProps => {
    const {rmType} = buttonProps
    onDepartmentTap(rmType)
  }
  const onKeyDown = buttonProps => {
    const {rmType} = buttonProps
	if (event.key === "Enter") {
		onDepartmentTap(rmType)
	}
  }
  const onClickEqStd = buttonProps => {
	const {eqStd} = buttonProps
    onEqStdTap(eqStd)
  }
  const onKeyDownEqStd = buttonProps => {
	const {eqStd} = buttonProps
	if (event.key === "Enter") {
		onEqStdTap(eqStd)
	}
  }
  const onClickAllEqStd = buttonProps => {
    onEqStdTap("toggle")
  }
  const onKeyDownAllEqStd = buttonProps => {
	const {eqStd} = buttonProps
	if (event.key === "Enter") {
		onEqStdTap("toggle")
	}
  }
  
  let eqstdList = Object.values(eqstds)
  let departmentList = Object.values(departments)
  
  return eqstdList.length || departmentList.length ? (
    <ListContainer id="Legend">
	  <OverflowContainer>
		<StyledUnorderedList3>
			<StyledLi key="refreshAll">
			  <RefreshButton
				color="white"
				onClick={onClickAllEqStd}
                onKeyDown={onKeyDownAllEqStd}
			  />
			</StyledLi>
		</StyledUnorderedList3>
        <StyledUnorderedList>
          {eqstdList.map(item => {
            const {eqStd, color, stdDescription} = item
            return (
              eqStd && (
                <StyledLi key={eqStd}>
                  <EqStdButton
                    label={stdDescription || eqStd}
                    color={color}
                    onClick={onClickEqStd}
                    onKeyDown={onKeyDownEqStd}
                    {...item}
                  />
                </StyledLi>
              )
            )
          })}
        </StyledUnorderedList>
        <StyledUnorderedList2>
          {departmentList.map(item => {
            const {rmType, color, rmTypeDesc} = item
            return (
              rmType && (
                <StyledLi key={rmType}>
                  <DepartmentButton
                    label={rmTypeDesc || rmType}
                    color={color}
                    onClick={onClick}
                    onKeyDown={onKeyDown}
                    {...item}
                  />
                </StyledLi>
              )
            )
          })}
        </StyledUnorderedList2>
	  </OverflowContainer>
    </ListContainer>
  ) : null
}
/* 
export const DepartmentList = ({departments, onDepartmentTap}) => {
  const onClick = buttonProps => {
    const {eqStd} = buttonProps
    onDepartmentTap(eqStd)
  }

  let departmentList = Object.values(departments)
  return departmentList.length ? (
    <ListContainer>
      <OverflowContainer>
        <StyledUnorderedList>
          {departmentList.map(item => {
            const {eqStd, color, stdDescription} = item
            return (
              eqStd && (
                <li key={eqStd}>
                  <DepartmentButton
                    label={stdDescription || eqStd}
                    color={color}
                    onClick={onClick}
                    {...item}
                  />
                </li>
              )
            )
          })}
        </StyledUnorderedList>
      </OverflowContainer>
    </ListContainer>
  ) : null
}
 */

 export default DepartmentList
